import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {ContestComponent} from './contest.component';
import {DeathService} from './death.service';
import {ContestDetailComponent} from './contest-detail.component';
import {QualifiedDeathPipe} from './pipe/qualified-death.pipe';
import {NonQualifiedDeathPipe} from './pipe/non-qualified-death.pipe';
import {CurrentContestSummaryComponent} from './current-contest-summary.component';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
  declarations: [
      AppComponent,
      ContestComponent,
      ContestDetailComponent,
      CurrentContestSummaryComponent,
      QualifiedDeathPipe,
      NonQualifiedDeathPipe ],

    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule ],
  providers: [DeathService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/app.module.ts